import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import {
  PresaleSignUpPage,
  presaleCampaignSearchSchema,
  presaleUtmSearchFragment,
} from "@/features/presale";
import { maskSearchFragment } from "@/features/shared/route-masking";

const searchSchema = z.object({
  ...presaleCampaignSearchSchema.shape,
  // An ENTRY point: `/presale`'s `beforeLoad` forwards only what its schema validated, so
  // an unlisted `utm_*` would die on the hop to step 1 before any component renders.
  ...presaleUtmSearchFragment,
  ...maskSearchFragment,
});

export const Route = createFileRoute("/(member)/(public)/presale/sign-up")({
  component: RouteComponent,
  validateSearch: searchSchema,
  head: () => ({
    meta: [
      { title: "Birdwatch - Founding Membership" },
      { name: "description", content: "Reserve your Founding Membership" },
    ],
  }),
});

function RouteComponent() {
  return <PresaleSignUpPage search={Route.useSearch()} />;
}
